<template>
  <div>
    <head>
      <meta charset="utf-8" />
      <title>Revenue Stream Details</title>
      <meta name="viewport" content="width=device-width, initial-scale=1.0">
      <meta content="Revenue Stream Details Report" name="description" />
      <meta content="County Revenue System" name="author" />
      <!-- App favicon -->
      <link rel="shortcut icon" href="assets/images/favicon.png">

      <!-- Bootstrap Css -->
      <link href="assets/css/bootstrap.min.css" id="bootstrap-style" rel="stylesheet" type="text/css" />
      <!-- Icons Css -->
      <link href="assets/css/icons.min.css" rel="stylesheet" type="text/css" />
      <!-- App Css-->
      <link href="assets/css/app.min.css" id="app-style" rel="stylesheet" type="text/css" />
      <!-- custom Css-->
      <link href="assets/css/custom.css" id="app-style" rel="stylesheet" type="text/css" />
    </head>

    <body @contextmenu.prevent data-sidebar="dark">
    <NavigationBar/>
    <div id="content" class="content-minimize">
      <div class="page-content">
        <div class="container-fluid">

          <!-- Page Title -->
          <div class="row">
            <div class="col-12">
              <div class="page-title-box d-sm-flex align-items-center justify-content-between">
                <h4 class="mb-sm-0 font-size-18">Revenue Stream Details</h4>
                <div class="page-title-right">
                  <ol class="breadcrumb m-0">
                    <li class="breadcrumb-item"><a href="javascript: void(0);" @click="gotTo('dashboard')">Dashboard</a></li>
                    <li class="breadcrumb-item"><a href="javascript: void(0);" @click="goBack">Revenue Summary</a></li>
                    <li class="breadcrumb-item active">Stream Details</li>
                  </ol>
                </div>
              </div>
            </div>
          </div>

          <!-- Stream Info Header -->
          <div class="row mb-4">
            <div class="col-12">
              <div class="card bg-primary text-white">
                <div class="card-body">
                  <div class="row align-items-center">
                    <div class="col-md-8">
                      <div class="d-flex align-items-center">
                        <div class="avatar-lg me-3">
                          <span class="avatar-title rounded-circle bg-white bg-soft-light">
                            <i :class="getStreamIcon()" class="text-primary" style="font-size: 32px;"></i>
                          </span>
                        </div>
                        <div>
                          <h3 class="text-white mb-1">{{streamName}}</h3>
                          <p class="mb-0 text-white-50">
                            <strong>Income Type Prefix:</strong> {{incomeTypePrefix || 'N/A'}}
                          </p>
                          <p class="mb-0 text-white-50">
                            <i class="bx bx-calendar me-1"></i>
                            <span class="me-3">From: <strong>{{moment(dateFrom).format('DD/MM/YYYY')}}</strong></span>
                            <span>To: <strong>{{moment(dateTo).format('DD/MM/YYYY')}}</strong></span>
                          </p>
                          <!-- Filter Info Display -->
                          <div v-if="selectedSubCounty || selectedWard || selectedZone" class="mt-2">
                            <span class="badge bg-light text-primary me-2" v-if="selectedSubCounty">
                              <i class="bx bx-map me-1"></i>{{getSubCountyName(selectedSubCounty)}}
                            </span>
                            <span class="badge bg-light text-primary me-2" v-if="selectedWard">
                              <i class="bx bx-location-plus me-1"></i>{{getWardName(selectedWard)}}
                            </span>
                            <span class="badge bg-light text-primary" v-if="selectedZone">
                              <i class="bx bx-target-lock me-1"></i>{{getZoneName(selectedZone)}}
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="col-md-4 text-md-end mt-3 mt-md-0">
                      <button @click="goBack" class="btn btn-light me-2">
                        <i class="bx bx-arrow-back me-1"></i> Back
                      </button>
                      <button @click="refreshData" class="btn btn-outline-light" :disabled="loading">
                        <i class="bx bx-refresh" :class="{'bx-spin': loading}"></i> Refresh
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- Summary Cards -->
          <div class="row mb-4">
            <div class="col-xl-3 col-md-6">
              <div class="card mini-stats-wid">
                <div class="card-body">
                  <div class="d-flex">
                    <div class="flex-grow-1">
                      <p class="text-muted fw-medium">Total Revenue</p>
                      <h4 class="mb-0">{{formatPrice(grandTotal)}}</h4>
                    </div>
                    <div class="flex-shrink-0 align-self-center">
                      <div class="mini-stat-icon avatar-sm rounded-circle bg-primary">
                        <span class="avatar-title">
                          <i class="bx bx-money font-size-24"></i>
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="col-xl-3 col-md-6">
              <div class="card mini-stats-wid">
                <div class="card-body">
                  <div class="d-flex">
                    <div class="flex-grow-1">
                      <p class="text-muted fw-medium">Total Transactions</p>
                      <h4 class="mb-0">{{totalTransactions.toLocaleString()}}</h4>
                    </div>
                    <div class="flex-shrink-0 align-self-center">
                      <div class="mini-stat-icon avatar-sm rounded-circle bg-success">
                        <span class="avatar-title">
                          <i class="bx bx-receipt font-size-24"></i>
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="col-xl-3 col-md-6">
              <div class="card mini-stats-wid">
                <div class="card-body">
                  <div class="d-flex">
                    <div class="flex-grow-1">
                      <p class="text-muted fw-medium">Total Agents</p>
                      <h4 class="mb-0">{{totalUniqueAgents.toLocaleString()}}</h4>
                    </div>
                    <div class="flex-shrink-0 align-self-center">
                      <div class="mini-stat-icon avatar-sm rounded-circle bg-info">
                        <span class="avatar-title">
                          <i class="bx bx-user font-size-24"></i>
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="col-xl-3 col-md-6">
              <div class="card mini-stats-wid">
                <div class="card-body">
                  <div class="d-flex">
                    <div class="flex-grow-1">
                      <p class="text-muted fw-medium">Income Types</p>
                      <h4 class="mb-0">{{revenueDetails.length}}</h4>
                    </div>
                    <div class="flex-shrink-0 align-self-center">
                      <div class="mini-stat-icon avatar-sm rounded-circle bg-warning">
                        <span class="avatar-title">
                          <i class="bx bx-list-ul font-size-24"></i>
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- Filters -->
          <div class="row mb-4">
            <div class="col-12">
              <div class="card">
                <div class="card-body">
                  <div class="row align-items-end">
                    <div class="col-md-2">
                      <label class="form-label">Sub County</label>
                      <select v-model="selectedSubCounty" class="form-select form-select-sm" @change="onSubCountyChange">
                        <option value="">All Sub Counties</option>
                        <option v-for="sc in subCounties" :key="sc.id" :value="sc.id">
                          {{sc.name}}
                        </option>
                      </select>
                    </div>
                    <div class="col-md-2">
                      <label class="form-label">Ward</label>
                      <select v-model="selectedWard" class="form-select form-select-sm" @change="onWardChange" :disabled="!selectedSubCounty">
                        <option value="">All Wards</option>
                        <option v-for="ward in filteredWards" :key="ward.id" :value="ward.id">
                          {{ward.name}}
                        </option>
                      </select>
                    </div>
                    <div class="col-md-2">
                      <label class="form-label">Zone</label>
                      <select v-model="selectedZone" class="form-select form-select-sm" @change="onZoneChange" :disabled="!selectedWard">
                        <option value="">All Zones</option>
                        <option v-for="zone in filteredZones" :key="zone.id" :value="zone.id">
                          {{zone.name}}
                        </option>
                      </select>
                    </div>
                    <div class="col-md-3">
                      <label class="form-label">Search</label>
                      <div class="input-group input-group-sm">
                        <span class="input-group-text">
                          <i class="bx bx-search"></i>
                        </span>
                        <input
                            v-model="searchQuery"
                            type="text"
                            class="form-control"
                            placeholder="Search income types..."
                            @input="handleSearch"
                        >
                        <button
                            v-if="searchQuery"
                            class="btn btn-outline-secondary"
                            type="button"
                            @click="clearSearch"
                        >
                          <i class="bx bx-x"></i>
                        </button>
                      </div>
                    </div>
                    <div class="col-md-2">
                      <button
                          v-if="getRight('DOWNLOAD BY STREAMS REPORTS')"
                          @click="downloadCSV"
                          class="btn btn-primary btn-sm w-100"
                          :disabled="loading || revenueDetails.length === 0"
                      >
                        <i class="bx bx-download me-1"></i> CSV
                      </button>
                    </div>
                    <div class="col-md-1" v-if="selectedSubCounty || selectedWard || selectedZone">
                      <button @click="clearLocationFilters" class="btn btn-outline-secondary btn-sm w-100" title="Clear filters">
                        <i class="bx bx-x"></i>
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- Main Details Table -->
          <div class="row">
            <div class="col-12">
              <div class="card">
                <div class="card-header bg-white">
                  <div class="row align-items-center">
                    <div class="col-md-6">
                      <h4 class="card-title mb-0">Income Type Breakdown</h4>
                      <p class="text-muted mb-0 mt-1">
                        Detailed breakdown by income type description
                      </p>
                    </div>
                    <div class="col-md-6 text-md-end">
                      <small class="text-muted">
                        Showing {{filteredAndSortedDetails.length}} of {{revenueDetails.length}} items
                      </small>
                    </div>
                  </div>
                </div>

                <div class="card-body">
                  <!-- Details Table -->
                  <div class="table-responsive">
                    <table class="table table-hover align-middle mb-0" v-if="!loading && revenueDetails.length > 0">
                      <thead class="table-dark">
                      <tr>
                        <th style="width: 5%">#</th>
                        <th
                            style="width: 30%; cursor: pointer;"
                            @click="sortBy('incomeTypeDescription')"
                            class="sortable-header"
                        >
                          Income Type Description
                          <i class="bx ms-1" :class="getSortIcon('incomeTypeDescription')"></i>
                          <span class="badge bg-soft-info text-info ms-2" style="font-size: 10px; font-weight: normal;">
                            <i class="bx bx-mouse"></i> Click for details
                          </span>
                        </th>
                        <th
                            style="width: 20%; cursor: pointer;"
                            @click="sortBy('feeDescription')"
                            class="sortable-header"
                        >
                          Fee Description
                          <i class="bx ms-1" :class="getSortIcon('feeDescription')"></i>
                        </th>
                        <th
                            class="text-center sortable-header"
                            style="width: 15%; cursor: pointer;"
                            @click="sortBy('totalTransactions')"
                        >
                          Transactions
                          <i class="bx ms-1" :class="getSortIcon('totalTransactions')"></i>
                        </th>
                        <th
                            class="text-center sortable-header"
                            style="width: 10%; cursor: pointer;"
                            @click="sortBy('totalAgents')"
                        >
                          Agents
                          <i class="bx ms-1" :class="getSortIcon('totalAgents')"></i>
                        </th>
                        <th
                            class="text-end sortable-header"
                            style="width: 20%; cursor: pointer;"
                            @click="sortBy('amountCollected')"
                        >
                          Amount Collected
                          <i class="bx ms-1" :class="getSortIcon('amountCollected')"></i>
                        </th>
                      </tr>
                      </thead>
                      <tbody>
                      <tr v-for="(detail, index) in paginatedDetails" :key="index">
                        <td>{{(currentPage - 1) * itemsPerPage + index + 1}}</td>
                        <td class="clickable-cell" @click="viewDetails('reports-streams-details-transactions',detail,detail.amountCollected)">
                          <div class="d-flex align-items-center">
                            <div class="flex-grow-1">
                              <h6 class="mb-0 text-primary">
                                {{detail.incomeTypeDescription}}
                                <i class="bx bx-right-arrow-alt ms-1"></i>
                              </h6>
                              <small class="text-muted">
                                <i class="bx bx-calendar-event me-1"></i>
                                {{moment(detail.firstTransactionDate).format('DD/MM/YY')}} -
                                {{moment(detail.lastTransactionDate).format('DD/MM/YY')}}
                              </small>
                            </div>
                          </div>
                        </td>
                        <td>
                          <div
                              v-if="detail.feeDescription"
                              class="fee-description-wrapper"
                              @mouseenter="showTooltip(index, detail.feeDescription)"
                              @mouseleave="hideTooltip"
                          >
                            <span class="text-muted fee-description-cell">
                              {{truncateFeeDescription(detail.feeDescription)}}
                            </span>
                            <div
                                v-if="activeTooltip === index"
                                class="custom-tooltip"
                                @click.stop
                            >
                              {{detail.feeDescription}}
                            </div>
                          </div>
                          <span v-else class="text-muted">N/A</span>
                        </td>
                        <td class="text-center">
                          <span class="badge bg-soft-primary text-primary">
                            {{Number(detail.totalTransactions).toLocaleString()}}
                          </span>
                        </td>
                        <td class="text-center">
                          <span class="badge bg-soft-info text-info">
                            {{Number(detail.totalAgents).toLocaleString()}}
                          </span>
                        </td>
                        <td class="text-end">
                          <strong>{{formatPrice(detail.amountCollected)}}</strong>
                          <br>
                          <small class="text-muted">
                            {{calculatePercentage(detail.amountCollected)}}%
                          </small>
                        </td>
                      </tr>
                      </tbody>
                      <tfoot class="table-light">
                      <tr>
                        <td colspan="3" class="text-end fw-bold">
                          <span v-if="searchQuery || selectedSubCounty || selectedWard || selectedZone" class="text-muted me-2">(Filtered)</span>
                          TOTALS
                        </td>
                        <td class="text-center">
                          <strong class="text-primary">{{Number(filteredTotalTransactions).toLocaleString()}}</strong>
                        </td>
                        <td class="text-center">
                          <strong class="text-info">{{Number(filteredTotalAgents).toLocaleString()}}</strong>
                        </td>
                        <td class="text-end">
                          <h5 class="mb-0 text-success">{{formatPrice(filteredGrandTotal)}}</h5>
                        </td>
                      </tr>
                      </tfoot>
                    </table>

                    <!-- Pagination -->
                    <div v-if="!loading && totalPages > 1" class="row mt-3">
                      <div class="col-sm-12 col-md-5">
                        <div class="dataTables_info">
                          Showing {{(currentPage - 1) * itemsPerPage + 1}} to
                          {{Math.min(currentPage * itemsPerPage, filteredAndSortedDetails.length)}}
                          of {{filteredAndSortedDetails.length}} entries
                        </div>
                      </div>
                      <div class="col-sm-12 col-md-7">
                        <div class="dataTables_paginate paging_simple_numbers float-end">
                          <ul class="pagination pagination-rounded">
                            <li class="paginate_button page-item previous" :class="{disabled: currentPage === 1}">
                              <a href="javascript: void(0);" @click.prevent="currentPage = 1" class="page-link">
                                <i class="mdi mdi-chevron-double-left"></i>
                              </a>
                            </li>
                            <li class="paginate_button page-item previous" :class="{disabled: currentPage === 1}">
                              <a href="javascript: void(0);" @click.prevent="currentPage > 1 && currentPage--" class="page-link">
                                <i class="mdi mdi-chevron-left"></i>
                              </a>
                            </li>

                            <li v-for="page in displayedPages" :key="page"
                                class="paginate_button page-item"
                                :class="{active: currentPage === page, disabled: page === '...'}">
                              <a href="javascript: void(0);" @click.prevent="page !== '...' && (currentPage = page)" class="page-link">
                                {{page}}
                              </a>
                            </li>

                            <li class="paginate_button page-item next" :class="{disabled: currentPage === totalPages}">
                              <a href="javascript: void(0);" @click.prevent="currentPage < totalPages && currentPage++" class="page-link">
                                <i class="mdi mdi-chevron-right"></i>
                              </a>
                            </li>
                            <li class="paginate_button page-item next" :class="{disabled: currentPage === totalPages}">
                              <a href="javascript: void(0);" @click.prevent="currentPage = totalPages" class="page-link">
                                <i class="mdi mdi-chevron-double-right"></i>
                              </a>
                            </li>
                          </ul>
                        </div>
                      </div>
                    </div>

                    <!-- Loading State -->
                    <div v-if="loading" class="text-center py-5">
                      <div class="spinner-border text-primary" role="status">
                        <span class="visually-hidden">Loading...</span>
                      </div>
                      <p class="mt-3 mb-0">Loading revenue details...</p>
                    </div>

                    <!-- Empty State -->
                    <div v-if="!loading && revenueDetails.length === 0" class="text-center py-5">
                      <img :src="'./assets/images/no-results.png'" alt="No results" style="width: 150px; opacity: 0.5;">
                      <h5 class="mt-3">No Data Available</h5>
                      <p class="text-muted">No revenue details found for the selected criteria.</p>
                      <button v-if="selectedSubCounty || selectedWard || selectedZone" class="btn btn-sm btn-primary mt-2" @click="clearLocationFilters">
                        <i class="bx bx-refresh me-1"></i>Clear Filters and Retry
                      </button>
                    </div>

                    <!-- No Results State (after filtering) -->
                    <div v-if="!loading && revenueDetails.length > 0 && filteredAndSortedDetails.length === 0" class="text-center py-5">
                      <img :src="'./assets/images/no-results.png'" alt="No results" style="width: 150px; opacity: 0.5;">
                      <h5 class="mt-3">No Matching Results</h5>
                      <p class="text-muted">No revenue details match your filter criteria.</p>
                      <button class="btn btn-sm btn-primary mt-2" @click="clearLocationFilters">
                        <i class="bx bx-x me-1"></i>Clear Filters
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- Breakdown Cards Row -->
          <div class="row" v-if="!loading && revenueDetails.length > 0">
            <!-- Sub County Breakdown -->
            <div class="col-lg-6" v-if="subCountyBreakdown.length > 0">
              <div class="card">
                <div class="card-header bg-white">
                  <h5 class="card-title mb-0">
                    <i class="bx bx-map me-2"></i>Sub County Breakdown
                  </h5>
                </div>
                <div class="card-body">
                  <div class="table-responsive" style="max-height: 400px; overflow-y: auto;">
                    <table class="table table-sm table-hover mb-0">
                      <thead class="table-light sticky-top">
                      <tr>
                        <th>Sub County</th>
                        <th class="text-center">Transactions</th>
                        <th class="text-end">Amount</th>
                      </tr>
                      </thead>
                      <tbody>
                      <tr v-for="(sc, index) in subCountyBreakdown" :key="index">
                        <td>
                          <strong>{{sc.subCountyName}}</strong>
                        </td>
                        <td class="text-center">
                          <span class="badge bg-soft-primary text-primary">
                            {{Number(sc.totalTransactions).toLocaleString()}}
                          </span>
                        </td>
                        <td class="text-end">
                          <strong>{{formatPrice(sc.amountCollected)}}</strong>
                          <br>
                          <small class="text-muted">{{calculatePercentage(sc.amountCollected)}}%</small>
                        </td>
                      </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>

            <!-- Ward Breakdown -->
            <div class="col-lg-6" v-if="wardBreakdown.length > 0">
              <div class="card">
                <div class="card-header bg-white">
                  <h5 class="card-title mb-0">
                    <i class="bx bx-location-plus me-2"></i>Ward Breakdown
                  </h5>
                </div>
                <div class="card-body">
                  <div class="table-responsive" style="max-height: 400px; overflow-y: auto;">
                    <table class="table table-sm table-hover mb-0">
                      <thead class="table-light sticky-top">
                      <tr>
                        <th>Ward</th>
                        <th class="text-center">Transactions</th>
                        <th class="text-end">Amount</th>
                      </tr>
                      </thead>
                      <tbody>
                      <tr v-for="(ward, index) in wardBreakdown.slice(0, 10)" :key="index">
                        <td>
                          <strong>{{ward.wardName}}</strong>
                          <br>
                          <small class="text-muted">{{ward.subCountyName}}</small>
                        </td>
                        <td class="text-center">
                          <span class="badge bg-soft-primary text-primary">
                            {{Number(ward.totalTransactions).toLocaleString()}}
                          </span>
                        </td>
                        <td class="text-end">
                          <strong>{{formatPrice(ward.amountCollected)}}</strong>
                          <br>
                          <small class="text-muted">{{calculatePercentage(ward.amountCollected)}}%</small>
                        </td>
                      </tr>
                      </tbody>
                    </table>
                  </div>
                  <div class="text-center mt-2" v-if="wardBreakdown.length > 10">
                    <small class="text-muted">Showing top 10 of {{wardBreakdown.length}} wards</small>
                  </div>
                </div>
              </div>
            </div>
          </div>

        </div>
      </div>

      <footer class="footer">
        <div class="container-fluid">
          <div class="row">
            <div class="col-sm-6">
              ©{{new Date().getFullYear()}} County Revenue System
            </div>
            <div class="col-sm-6">
              <div class="text-sm-end d-sm-block">
                Revenue Stream Details Report
              </div>
            </div>
          </div>
        </div>
      </footer>
    </div>
    </body>
  </div>
</template>

<script>
/* eslint-disable */
import NavigationBar from "@/components/Navigation";
import router from "@/router";
import {biller, execute, execute2, getRight} from "@/api";
import moment from 'moment';

export default {
  name: "ReportsSubCountyStreamsDetails",
  components: {NavigationBar},

  data() {
    return {
      loading: false,

      // Stream info from session
      streamName: '',
      incomeTypePrefix: '',
      dateFrom: '',
      dateTo: '',

      // Main data
      revenueDetails: [],
      subCountyBreakdown: [],
      wardBreakdown: [],
      topCollectors: [],
      paymentMethods: [],
      dailyTrend: [],

      totalTransactions: 0,
      totalUniqueAgents: 0,
      grandTotal: 0,

      // Filters
      selectedSubCounty: '',
      selectedWard: '',
      selectedZone: '',
      subCounties: [],
      wards: [],
      zones: [],

      // Search and Sort
      searchQuery: '',
      sortColumn: 'amountCollected',
      sortDirection: 'desc',

      // Pagination
      currentPage: 1,
      itemsPerPage: 50,

      // Tooltip
      activeTooltip: null
    }
  },

  computed: {
    filteredWards() {
      if (!this.selectedSubCounty) {
        return this.wards;
      }
      return this.wards.filter(w => w.subCountyId === this.selectedSubCounty);
    },

    filteredZones() {
      if (!this.selectedWard) {
        return this.zones;
      }
      return this.zones.filter(z => z.wardId === this.selectedWard);
    },

    // Filter details based on search query
    filteredDetails() {
      if (!this.searchQuery.trim()) {
        return this.revenueDetails;
      }

      const query = this.searchQuery.toLowerCase();
      return this.revenueDetails.filter(detail => {
        return detail.incomeTypeDescription.toLowerCase().includes(query) ||
            (detail.feeDescription && detail.feeDescription.toLowerCase().includes(query)) ||
            detail.totalTransactions.toString().includes(query) ||
            this.formatPrice(detail.amountCollected).toLowerCase().includes(query);
      });
    },

    // Apply sorting to filtered results
    filteredAndSortedDetails() {
      const details = [...this.filteredDetails];

      details.sort((a, b) => {
        let aVal = a[this.sortColumn];
        let bVal = b[this.sortColumn];

        // Handle numeric values
        if (this.sortColumn === 'amountCollected') {
          aVal = parseFloat(aVal);
          bVal = parseFloat(bVal);
        } else if (this.sortColumn === 'totalTransactions' || this.sortColumn === 'totalAgents') {
          aVal = parseInt(aVal);
          bVal = parseInt(bVal);
        } else {
          // String comparison (case-insensitive)
          aVal = aVal ? aVal.toString().toLowerCase() : '';
          bVal = bVal ? bVal.toString().toLowerCase() : '';
        }

        if (this.sortDirection === 'asc') {
          return aVal > bVal ? 1 : aVal < bVal ? -1 : 0;
        } else {
          return aVal < bVal ? 1 : aVal > bVal ? -1 : 0;
        }
      });

      return details;
    },

    // Paginated results
    paginatedDetails() {
      const start = (this.currentPage - 1) * this.itemsPerPage;
      const end = start + this.itemsPerPage;
      return this.filteredAndSortedDetails.slice(start, end);
    },

    // Pagination calculations
    totalPages() {
      return Math.ceil(this.filteredAndSortedDetails.length / this.itemsPerPage);
    },

    displayedPages() {
      const pages = [];
      const total = this.totalPages;
      const current = this.currentPage;

      if (total <= 7) {
        for (let i = 1; i <= total; i++) {
          pages.push(i);
        }
      } else {
        if (current <= 3) {
          for (let i = 1; i <= 5; i++) {
            pages.push(i);
          }
          pages.push('...');
          pages.push(total);
        } else if (current >= total - 2) {
          pages.push(1);
          pages.push('...');
          for (let i = total - 4; i <= total; i++) {
            pages.push(i);
          }
        } else {
          pages.push(1);
          pages.push('...');
          for (let i = current - 1; i <= current + 1; i++) {
            pages.push(i);
          }
          pages.push('...');
          pages.push(total);
        }
      }

      return pages;
    },

    // Calculate filtered totals
    filteredTotalTransactions() {
      return this.filteredDetails.reduce((sum, detail) => sum + parseInt(detail.totalTransactions || 0), 0);
    },

    filteredTotalAgents() {
      return this.filteredDetails.reduce((sum, detail) => sum + parseInt(detail.totalAgents || 0), 0);
    },

    filteredGrandTotal() {
      return this.filteredDetails.reduce((sum, detail) => sum + parseFloat(detail.amountCollected || 0), 0);
    }
  },

  watch: {
    filteredAndSortedDetails() {
      this.currentPage = 1;
    }
  },

  mounted() {
    this.loadSessionData();
    this.loadSubCountiesAndWards();
    this.getRevenueDetails();
    this.menuAccess();
  },

  methods: {
    menuAccess() {
      const data = new FormData();
      data.append("function", "menuAccess");
      data.append("menu", "Revenue Stream Details");
      data.append("sessionNames", sessionStorage.getItem("sessionNames"));
      data.append("sessionIdNo", sessionStorage.getItem("sessionIdNo"));
      execute(data, biller)
          .then(() => {})
          .catch(() => {});
    },

    getRight(type) {
      return getRight(type);
    },

    loadSessionData() {
      this.streamName = sessionStorage.getItem("revenueStreamName") || 'Revenue Stream';
      this.incomeTypePrefix = sessionStorage.getItem("incomeTypePrefix") || '';
      this.dateFrom = sessionStorage.getItem("dateFrom") || moment().startOf('month').format('YYYY-MM-DD');
      this.dateTo = sessionStorage.getItem("dateTo") || moment().endOf('month').format('YYYY-MM-DD');
    },

    loadSubCountiesAndWards() {
      const data = new FormData();
      data.append("function", "getSubCounties");

      execute2(data, biller)
          .then((res) => {
            if (res.data.success) {
              const subCountiesData = res.data.data.subCounties || [];

              // Extract unique subcounties
              const uniqueSubCounties = {};
              subCountiesData.forEach(item => {
                if (!uniqueSubCounties[item.subCountyID]) {
                  uniqueSubCounties[item.subCountyID] = {
                    id: item.subCountyID,
                    name: item.subCountyName
                  };
                }
              });

              this.subCounties = Object.values(uniqueSubCounties);

              // Extract wards
              this.wards = subCountiesData.map(item => ({
                id: item.wardID,
                name: item.wardName,
                subCountyId: item.subCountyID
              }));
            }
          })
          .catch((err) => {
            console.error('Error loading subcounties and wards:', err);
          });
    },

    loadZones(subCountyID, wardID) {
      const data = new FormData();
      data.append("function", "getZones");
      if (subCountyID) {
        data.append("subCountyID", subCountyID);
      }
      if (wardID) {
        data.append("wardID", wardID);
      }

      execute2(data, biller)
          .then((res) => {
            if (res.data.success) {
              this.zones = (res.data.data.zones || []).map(zone => ({
                id: zone.id,
                name: zone.zone,
                wardId: zone.wardID,
                subCountyId: zone.subCountyID
              }));
            } else {
              this.zones = [];
            }
          })
          .catch((err) => {
            console.error('Error loading zones:', err);
            this.zones = [];
          });
    },

    onSubCountyChange() {
      this.selectedWard = '';
      this.selectedZone = '';
      this.zones = [];
      if (this.selectedSubCounty) {
        this.loadZones(this.selectedSubCounty, null);
      }
      this.getRevenueDetails();
    },

    onWardChange() {
      this.selectedZone = '';
      if (this.selectedWard) {
        this.loadZones(this.selectedSubCounty, this.selectedWard);
      } else {
        this.zones = [];
      }
      this.getRevenueDetails();
    },

    onZoneChange() {
      this.getRevenueDetails();
    },

    clearLocationFilters() {
      this.selectedSubCounty = '';
      this.selectedWard = '';
      this.selectedZone = '';
      this.zones = [];
      this.searchQuery = '';
      this.getRevenueDetails();
    },

    getSubCountyName(id) {
      const sc = this.subCounties.find(s => s.id === id);
      return sc ? sc.name : id;
    },

    getWardName(id) {
      const ward = this.wards.find(w => w.id === id);
      return ward ? ward.name : id;
    },

    getZoneName(id) {
      const zone = this.zones.find(z => z.id === id);
      return zone ? zone.name : id;
    },

    getRevenueDetails() {
      this.loading = true;

      const data = new FormData();
      data.append("function", "getRevenueStreamSummaryDetails");
      data.append("incomeTypePrefix", this.incomeTypePrefix);
      data.append("dateFrom", this.dateFrom);
      data.append("dateTo", this.dateTo);

      if (this.selectedSubCounty) {
        data.append("subCountyID", this.selectedSubCounty);
      }

      if (this.selectedWard) {
        data.append("wardID", this.selectedWard);
      }

      if (this.selectedZone) {
        // Pass zone name, not ID (transactions table stores zone name)
        const zoneName = this.getZoneName(this.selectedZone);
        data.append("zone", zoneName);
      }

      execute2(data, biller)
          .then((res) => {
            this.loading = false;
            if (res.data.success) {
              const reportData = res.data.data.data;
              this.revenueDetails = reportData.revenueDetails || [];
              this.subCountyBreakdown = reportData.subCountyBreakdown || [];
              this.wardBreakdown = reportData.wardBreakdown || [];
              this.topCollectors = reportData.topCollectors || [];
              this.paymentMethods = reportData.paymentMethods || [];
              this.dailyTrend = reportData.dailyTrend || [];
              this.totalTransactions = reportData.totalTransactions || 0;
              this.totalUniqueAgents = reportData.totalUniqueAgents || 0;
              this.grandTotal = reportData.grandTotal || 0;

              this.currentPage = 1;
            } else {
              // Clear all data when response is not successful
              this.revenueDetails = [];
              this.subCountyBreakdown = [];
              this.wardBreakdown = [];
              this.topCollectors = [];
              this.paymentMethods = [];
              this.dailyTrend = [];
              this.totalTransactions = 0;
              this.totalUniqueAgents = 0;
              this.grandTotal = 0;

              console.error('API Error:', res.data.message);
            }
          })
          .catch((e) => {
            this.loading = false;

            // Clear all data on error
            this.revenueDetails = [];
            this.subCountyBreakdown = [];
            this.wardBreakdown = [];
            this.topCollectors = [];
            this.paymentMethods = [];
            this.dailyTrend = [];
            this.totalTransactions = 0;
            this.totalUniqueAgents = 0;
            this.grandTotal = 0;

            console.error('Error loading revenue details:', e);
          });
    },

    refreshData() {
      this.getRevenueDetails();
    },

    // Truncate fee description for display
    truncateFeeDescription(text, maxLength = 100) {
      if (!text) return 'N/A';
      if (text.length <= maxLength) return text;
      return text.substring(0, maxLength) + '...';
    },

    // Tooltip methods
    showTooltip(index, text) {
      if (text && text.length > 100) {
        this.activeTooltip = index;
      }
    },

    hideTooltip() {
      this.activeTooltip = null;
    },

    // Sorting methods
    sortBy(column) {
      if (this.sortColumn === column) {
        this.sortDirection = this.sortDirection === 'asc' ? 'desc' : 'asc';
      } else {
        this.sortColumn = column;
        this.sortDirection = column === 'incomeTypeDescription' ? 'asc' : 'desc';
      }
    },

    getSortIcon(column) {
      if (this.sortColumn !== column) {
        return 'bx-sort text-muted';
      }
      return this.sortDirection === 'asc' ? 'bx-sort-up text-primary' : 'bx-sort-down text-primary';
    },

    // Search methods
    handleSearch() {
      this.currentPage = 1;
    },

    clearSearch() {
      this.searchQuery = '';
      this.currentPage = 1;
    },

    viewDetails(route, item, amountCollected) {
      const incomeTypePrefix = item.incomeTypePrefix || "NULL";
      const incomeTypeDescription = item.incomeTypeDescription || "NULL";
      const feeDescription = item.feeDescription || "";

      sessionStorage.setItem("currentPage", route);
      sessionStorage.setItem("dateTo", this.dateTo);
      sessionStorage.setItem("dateFrom", this.dateFrom);
      sessionStorage.setItem("subCountyName", this.selectedSubCounty ? this.getSubCountyName(this.selectedSubCounty) : "");
      sessionStorage.setItem("subCountyID", this.selectedSubCounty || "");
      sessionStorage.setItem("wardName", this.selectedWard ? this.getWardName(this.selectedWard) : "");
      sessionStorage.setItem("wardID", this.selectedWard || "");
      sessionStorage.setItem("zone", this.selectedZone ? this.getZoneName(this.selectedZone) : "");
      sessionStorage.setItem("feeDescription", feeDescription);
      sessionStorage.setItem("incomeTypeDescription", incomeTypeDescription);
      sessionStorage.setItem("incomeTypePrefix", incomeTypePrefix);
      sessionStorage.setItem("amountCollected", amountCollected);

      router.push(route);
    },

    calculatePercentage(amount) {
      if (this.grandTotal === 0) return 0;
      return ((parseFloat(amount) / this.grandTotal) * 100).toFixed(1);
    },

    getStreamIcon() {
      const streamName = this.streamName.toUpperCase();
      const icons = {
        'PARKING': 'bx bx-car',
        'MARKETS': 'bx bx-store',
        'BUS PARK': 'bx bx-bus',
        'LAND RATES': 'bx bx-home',
        'SBP': 'bx bx-briefcase',
        'CESS': 'bx bx-package',
        'ADVERTS': 'bx bx-image',
        'BUILDING': 'bx bx-building',
        'PARK FEES': 'bx bx-tree'
      };

      for (let key in icons) {
        if (streamName.includes(key)) {
          return icons[key];
        }
      }
      return 'bx bx-receipt';
    },

    // Download CSV
    downloadCSV() {
      const dataToExport = this.searchQuery || this.selectedSubCounty || this.selectedWard || this.selectedZone
          ? this.filteredAndSortedDetails
          : this.revenueDetails;

      if (dataToExport.length === 0) {
        alert('No data available to download');
        return;
      }

      const headers = [
        '#',
        'Income Type Description',
        'Fee Description',
        'Transactions',
        'Agents',
        'Sub Counties',
        'Wards',
        'Amount Collected',
        'First Transaction Date',
        'Last Transaction Date'
      ];

      const rows = [];

      // Add metadata
      rows.push('COUNTY REVENUE SYSTEM - REVENUE STREAM DETAILS REPORT');
      rows.push('');
      rows.push(`Revenue Stream:,"${this.streamName}"`);
      rows.push(`Income Type Prefix:,"${this.incomeTypePrefix || 'N/A'}"`);
      rows.push(`Date Range:,"${moment(this.dateFrom).format('DD/MM/YYYY')} to ${moment(this.dateTo).format('DD/MM/YYYY')}"`);

      if (this.selectedSubCounty) {
        rows.push(`Sub County Filter:,"${this.getSubCountyName(this.selectedSubCounty)}"`);
      }

      if (this.selectedWard) {
        rows.push(`Ward Filter:,"${this.getWardName(this.selectedWard)}"`);
      }

      if (this.selectedZone) {
        rows.push(`Zone Filter:,"${this.getZoneName(this.selectedZone)}"`);
      }

      if (this.searchQuery) {
        rows.push(`Search Filter:,"${this.searchQuery}"`);
      }

      rows.push('');
      rows.push('SUMMARY TOTALS');
      rows.push(`Total Revenue:,${this.formatPrice(this.filteredGrandTotal)}`);
      rows.push(`Total Transactions:,${this.filteredTotalTransactions.toLocaleString()}`);
      rows.push(`Total Agents:,${this.filteredTotalAgents}`);
      rows.push(`Income Types:,${dataToExport.length}`);
      rows.push('');
      rows.push('');

      // Add main data headers
      rows.push(headers.join(','));

      // Add data rows
      dataToExport.forEach((detail, index) => {
        const row = [
          index + 1,
          `"${detail.incomeTypeDescription.replace(/"/g, '""')}"`,
          `"${(detail.feeDescription || 'N/A').replace(/"/g, '""')}"`,
          detail.totalTransactions,
          detail.totalAgents,
          detail.totalSubCounties || 0,
          detail.totalWards || 0,
          detail.amountCollected,
          moment(detail.firstTransactionDate).format('DD/MM/YYYY HH:mm'),
          moment(detail.lastTransactionDate).format('DD/MM/YYYY HH:mm')
        ];
        rows.push(row.join(','));
      });

      // Add totals row
      rows.push('');
      rows.push([
        '',
        '"TOTALS"',
        '',
        this.filteredTotalTransactions,
        this.filteredTotalAgents,
        '',
        '',
        this.filteredGrandTotal,
        '',
        ''
      ].join(','));

      // Add breakdown sections
      if (this.subCountyBreakdown.length > 0) {
        rows.push('');
        rows.push('');
        rows.push('SUB COUNTY BREAKDOWN');
        rows.push('Sub County,Transactions,Amount Collected');

        this.subCountyBreakdown.forEach(sc => {
          rows.push([
            `"${sc.subCountyName}"`,
            sc.totalTransactions,
            sc.amountCollected
          ].join(','));
        });
      }

      if (this.wardBreakdown.length > 0) {
        rows.push('');
        rows.push('');
        rows.push('WARD BREAKDOWN (Top 20)');
        rows.push('Ward,Sub County,Transactions,Amount Collected');

        this.wardBreakdown.slice(0, 20).forEach(ward => {
          rows.push([
            `"${ward.wardName}"`,
            `"${ward.subCountyName}"`,
            ward.totalTransactions,
            ward.amountCollected
          ].join(','));
        });
      }

      rows.push('');
      rows.push('');
      rows.push(`Report Generated:,${moment().format('DD/MM/YYYY HH:mm:ss')}`);
      rows.push(`Generated By:,${sessionStorage.getItem('sessionNames') || 'System'}`);
      rows.push('');
      rows.push('© ' + new Date().getFullYear() + ' County Revenue System');

      // Create CSV content
      const csvContent = rows.join('\n');
      const BOM = '\uFEFF';
      const blob = new Blob([BOM + csvContent], { type: 'text/csv;charset=utf-8;' });
      const link = document.createElement('a');
      const url = URL.createObjectURL(blob);

      // Generate filename
      let filename = `revenue_stream_details_${this.incomeTypePrefix}_${this.dateFrom}_to_${this.dateTo}`;
      if (this.selectedSubCounty) filename += `_${this.getSubCountyName(this.selectedSubCounty).replace(/\s+/g, '_')}`;
      if (this.selectedWard) filename += `_${this.getWardName(this.selectedWard).replace(/\s+/g, '_')}`;
      if (this.selectedZone) filename += `_${this.getZoneName(this.selectedZone).replace(/\s+/g, '_')}`;
      filename += '.csv';

      link.href = url;
      link.download = filename;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);

      setTimeout(() => {
        URL.revokeObjectURL(url);
      }, 100);
    },

    formatPrice(value) {
      const formatter = new Intl.NumberFormat('en-KE', {
        style: 'currency',
        currency: 'KES',
        minimumFractionDigits: 0,
        maximumFractionDigits: 0
      });
      return formatter.format(value);
    },

    moment(date) {
      return moment(date);
    },

    gotTo(route) {
      router.push(route);
    },

    goBack() {
      router.push('reports-streams');
    }
  }
}
</script>

<style scoped>
.bx-spin {
  animation: spin 1s linear infinite;
}

@keyframes spin {
  from { transform: rotate(0deg); }
  to { transform: rotate(360deg); }
}

.bg-soft-primary {
  background-color: rgba(50, 149, 239, 0.1);
}

.bg-soft-success {
  background-color: rgba(52, 195, 143, 0.1);
}

.bg-soft-info {
  background-color: rgba(80, 165, 241, 0.1);
}

.bg-soft-warning {
  background-color: rgba(244, 206, 109, 0.1);
}

.bg-soft-danger {
  background-color: rgba(244, 106, 106, 0.1);
}

.bg-soft-light {
  background-color: rgba(255, 255, 255, 0.2);
}

.sortable-header {
  user-select: none;
  transition: background-color 0.2s;
}

.sortable-header:hover {
  background-color: #212529 !important;
}

.sortable-header i {
  font-size: 0.875rem;
  vertical-align: middle;
}

.input-group-text {
  background-color: #f8f9fa;
  border-right: none;
}

.input-group .form-control {
  border-left: none;
}

.input-group .form-control:focus {
  box-shadow: none;
  border-color: #ced4da;
}

.pagination {
  margin-bottom: 0;
}

.page-link {
  color: #495057;
  border: 1px solid #dee2e6;
}

.page-item.active .page-link {
  background-color: #0d6efd;
  border-color: #0d6efd;
}

.page-item.disabled .page-link {
  color: #6c757d;
  pointer-events: none;
  background-color: #fff;
  border-color: #dee2e6;
}

.dataTables_info {
  padding-top: 0.85rem;
  color: #6c757d;
}

.badge {
  font-weight: 500;
}

.sticky-top {
  position: sticky;
  top: 0;
  z-index: 10;
}

.avatar-xs {
  height: 2rem;
  width: 2rem;
}

.avatar-sm {
  height: 3rem;
  width: 3rem;
}

.avatar-lg {
  height: 5rem;
  width: 5rem;
}

.avatar-title {
  align-items: center;
  display: flex;
  height: 100%;
  justify-content: center;
  width: 100%;
}

.dropdown-menu {
  min-width: 200px;
}

.dropdown-item {
  padding: 0.5rem 1rem;
}

.dropdown-item:hover {
  background-color: #f8f9fa;
}

.clickable-cell {
  cursor: pointer;
  transition: background-color 0.2s ease;
}

.clickable-cell:hover {
  background-color: #f8f9fa;
}

.clickable-cell:hover h6 {
  color: #0d6efd !important;
  text-decoration: underline;
}

.clickable-cell:hover i.bx-right-arrow-alt {
  transform: translateX(3px);
  transition: transform 0.2s ease;
}

/* Fee Description Cell with Tooltip */
.fee-description-wrapper {
  position: relative;
  display: inline-block;
}

.fee-description-cell {
  display: inline-block;
  max-width: 250px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  cursor: help;
}

.fee-description-cell:hover {
  color: #0d6efd;
}

.custom-tooltip {
  position: absolute;
  left: 0;
  top: 100%;
  z-index: 1050;
  background: #2c3e50;
  color: #fff;
  padding: 12px 16px;
  border-radius: 6px;
  font-size: 13px;
  white-space: normal;
  max-width: 500px;
  min-width: 300px;
  box-shadow: 0 4px 12px rgba(0,0,0,0.25);
  margin-top: 8px;
  line-height: 1.5;
  cursor: text;
  user-select: text;
  animation: fadeIn 0.2s ease-in;
}

.custom-tooltip::before {
  content: '';
  position: absolute;
  bottom: 100%;
  left: 20px;
  border: 6px solid transparent;
  border-bottom-color: #2c3e50;
}

@keyframes fadeIn {
  from {
    opacity: 0;
    transform: translateY(-5px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
</style>